import { useState, useEffect } from "react";

// Checkbox-list multi-select with an "Other" option that reveals a free-text
// input. `value` is a string array; any entries not in `options` are treated
// as "Other" text the user typed in (no literal "Other" sentinel is stored).
export default function MultiSelectWithOther({ options, value = [], allowOther, onChange }) {
  const otherValues = value.filter(v => !options.includes(v));
  const [otherChecked, setOtherChecked] = useState(otherValues.length > 0);
  const [otherText, setOtherText] = useState(otherValues[0] || "");

  useEffect(() => {
    const ov = value.filter(v => !options.includes(v));
    setOtherChecked(ov.length > 0);
    setOtherText(ov[0] || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.join("|")]);

  const toggleOption = (opt) => {
    const has = value.includes(opt);
    onChange(has ? value.filter(v => v !== opt) : [...value, opt]);
  };

  const toggleOther = () => {
    if (otherChecked) {
      onChange(value.filter(v => v !== otherText));
      setOtherChecked(false);
    } else {
      setOtherChecked(true);
    }
  };

  const updateOtherText = (text) => {
    setOtherText(text);
    const standardOnly = value.filter(v => options.includes(v));
    onChange(text.trim() ? [...standardOnly, text] : standardOnly);
  };

  const rowStyle = { display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "var(--text)", cursor: "pointer" };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
      {options.map(opt => (
        <label key={opt} style={rowStyle}>
          <input type="checkbox" checked={value.includes(opt)} onChange={() => toggleOption(opt)} />
          {opt}
        </label>
      ))}
      {allowOther && (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <label style={rowStyle}>
            <input type="checkbox" checked={otherChecked} onChange={toggleOther} />
            Other
          </label>
          {otherChecked && (
            <input
              type="text"
              value={otherText}
              onChange={e => updateOtherText(e.target.value)}
              placeholder="Type your own…"
              style={{
                marginLeft: 22, height: 28, border: "1px solid var(--cs-border)", borderRadius: "var(--radius)",
                padding: "0 8px", fontSize: 12, color: "var(--text)", outline: "none", maxWidth: 360,
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}
